import { ButtonProps } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import useSubmitLock from 'hooks/use-submit-lock'

type PrimaryButtonProps = {
  label: string
  handleClick: () => void
  loading?: boolean
  loadingText?: string
} & ButtonProps

const TranspotsLoadingButton = ({
  label,
  loading,
  loadingText,
  handleClick,
  disabled,
  ...rest
}: PrimaryButtonProps) => {
  const { isSubmitting, wrapClick } = useSubmitLock()
  const isBusy = !!loading || isSubmitting

  return (
    <LoadingButton
      sx={{
        minWidth: '250px',
        height: '36px',
        borderRadius: '6px',
        textTransform: 'capitalize',
        fontWeight: 700,
        '&.Mui-disabled': {
          bgcolor: 'action.disabledBackground',
          color: 'action.disabled',
        },
      }}
      loading={isBusy}
      disabled={!!disabled || isBusy}
      variant={isBusy ? 'outlined' : 'contained'}
      onClick={wrapClick(handleClick)}
      {...rest}
    >
      {isBusy ? (loadingText ?? 'Loading...') : label}
    </LoadingButton>
  )
}

export default TranspotsLoadingButton
